import { Amplify } from 'aws-amplify';
import { disable } from 'aws-amplify/analytics';
import * as Auth from 'aws-amplify/auth';

/**
 * Handles AWS Amplify configuration based
 * on environment variables coming from the right .env file
 */
export default function configure() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
        userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID as string
      }
    }
  });

  disable();
}

export { Auth };
